export function absoluteUrl(url) {
    let final_url = '';
    if (url && url.length > 0) {
        if (url.includes('http')) final_url = url;
        else final_url = 'http://' + url;
    }
    return final_url;
}